<router-outlet></router-outlet>

<nexus-toast-container></nexus-toast-container>
